import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Icon, Link } from 'components/ui';
import {
    fontWeights, lineHeights, space
} from 'style/config';
import anaUtils from 'analytics/utils';
import localeUtils from 'utils/LanguageLocale';
import urlUtils from 'utils/Url';
import pathSelector from 'selectors/historyLocation/pathSelector';
import { URL } from 'constants/Shared';
import HeaderEN from 'components/Header/locales/Header_en_US';
import HeaderFR from 'components/Header/locales/Header_fr_CA';

const { getLink } = urlUtils;
const { getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(HeaderEN, HeaderFR);

const OffersDrop = ({ stacked = false }) => {
    const [isHovered, setIsHovered] = useState(false);
    const currentPath = useSelector(pathSelector);
    const isSelected = Boolean(currentPath) && currentPath.indexOf(URL.BEAUTY_OFFERS) !== -1;

    const isActive = isHovered || isSelected;

    const handleClick = () => {
        anaUtils.setNextPageData({ navigationInfo: anaUtils.buildNavPath(['top nav', 'offers']) });
    };

    return (
        <Link
            href={getLink(URL.BEAUTY_OFFERS)}
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onFocus={() => setIsHovered(true)}
            onBlur={() => setIsHovered(false)}
            aria-current={isSelected ? 'page' : undefined}
            disableUnderline
            css={[styles.trigger, stacked && styles.triggerStacked]}
            data-at={Sephora.debug.dataAt('offers_header')}
        >
            <Icon
                name={isActive ? 'offersActiveTilted' : 'offers'}
                color='black'
                size={24}
                marginRight={stacked ? 0 : 3}
                marginBottom={stacked ? 1 : 0}
                css={!isActive && styles.iconInactive}
            />
            <span css={[stacked && styles.stackedLabel, isActive && styles.triggerLabelActive]}>{getText('offers')}</span>
        </Link>
    );
};

const styles = {
    trigger: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: space[4],
        paddingRight: space[4],
        height: '100%',
        lineHeight: lineHeights.tight,
        cursor: 'pointer'
    },
    triggerStacked: {
        flexDirection: 'column'
    },
    iconInactive: {
        opacity: 0.6
    },
    stackedLabel: {
        maxWidth: 72,
        overflow: 'hidden',
        textAlign: 'center',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: lineHeights.tight,
        fontWeight: fontWeights.bold
    },
    triggerLabelActive: {
        fontWeight: fontWeights.bold
    }
};

export default wrapFunctionalComponent(OffersDrop, 'OffersDrop');
